/** Opciones de tamaño de fuente para la leyenda de pastel/dona. */
export const PIE_LEGEND_FONT_SIZE_OPTIONS = [
  { value: 'sm', label: 'Pequeña', px: 13, box: 11 },
  { value: 'md', label: 'Mediana', px: 16, box: 13 },
  { value: 'lg', label: 'Grande', px: 18, box: 14 },
  { value: 'xl', label: 'Muy grande', px: 22, box: 16 },
];

export const DEFAULT_PIE_LEGEND_FONT_SIZE = 'lg';

const BY_VALUE = Object.fromEntries(PIE_LEGEND_FONT_SIZE_OPTIONS.map((o) => [o.value, o]));

export function normalizePieLegendFontSize(value) {
  const key = String(value || '').trim();
  return BY_VALUE[key] ? key : DEFAULT_PIE_LEGEND_FONT_SIZE;
}

export function resolvePieLegendFontSize(value) {
  return BY_VALUE[normalizePieLegendFontSize(value)] || BY_VALUE[DEFAULT_PIE_LEGEND_FONT_SIZE];
}

/** Escala px/caja de leyenda según ancho del contenedor (móvil / embed estrecho). */
export function scalePieLegendFontSize(resolved, containerWidth) {
  if (!resolved) return resolved;
  if (!containerWidth || containerWidth <= 0) return resolved;
  const scale = Math.min(1, Math.max(0.6, containerWidth / 720));
  return {
    ...resolved,
    px: Math.max(10, Math.round(resolved.px * scale)),
    box: Math.max(8, Math.round(resolved.box * scale)),
  };
}

/** Leyenda lateral roba mucho ancho en móvil; pasar abajo mejora la torta. */
export function resolvePieLegendPositionForViewport(configuredPosition, containerWidth) {
  const pos = configuredPosition || 'left';
  if (!containerWidth || containerWidth >= 640) return pos;
  if (pos === 'left' || pos === 'right') return 'bottom';
  return pos;
}

/** Leyenda compacta (solo %) cuando el ancho es muy reducido. */
export function isCompactPieLegendViewport(containerWidth) {
  return containerWidth > 0 && containerWidth < 520;
}

/** Ubicación de métricas (valor / %) en pastel/dona. */
export const PIE_LABEL_POSITION_OPTIONS = [
  { value: 'inside', label: 'Dentro del pastel' },
  { value: 'outside', label: 'Callouts (fuera)' },
  { value: 'legend', label: 'En la leyenda' },
  { value: 'legendAndChart', label: 'Leyenda y gráfico' },
];

export const DEFAULT_PIE_LABEL_POSITION = 'inside';

/** Porcentaje mínimo del segmento para dibujar etiqueta en el gráfico (modo leyenda + gráfico). */
export const DEFAULT_PIE_MIN_CHART_LABEL_PERCENT = 7;

/** Ángulo mínimo del arco (grados) para etiqueta dentro del segmento. */
export const DEFAULT_PIE_MIN_CHART_LABEL_ANGLE_DEG = 18;

const LABEL_POSITIONS = new Set(PIE_LABEL_POSITION_OPTIONS.map((o) => o.value));

export function normalizePieLabelPosition(value) {
  const key = String(value || '').trim();
  return LABEL_POSITIONS.has(key) ? key : DEFAULT_PIE_LABEL_POSITION;
}

export function pieLabelsInLegend(position) {
  const p = normalizePieLabelPosition(position);
  return p === 'legend' || p === 'legendAndChart';
}

export function pieLabelsOnChart(position) {
  const p = normalizePieLabelPosition(position);
  return p === 'inside' || p === 'outside' || p === 'legendAndChart';
}

/** Modo de dibujo en canvas: inside | outside | none */
export function pieChartDrawMode(position) {
  const p = normalizePieLabelPosition(position);
  if (p === 'legend') return 'none';
  if (p === 'outside') return 'outside';
  return 'inside';
}

export function resolvePieMinChartLabelPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return DEFAULT_PIE_MIN_CHART_LABEL_PERCENT;
  return Math.min(25, Math.max(3, n));
}
